import { useEffect, useState} from 'react';
import {  Button, Form } from 'react-bootstrap';
import { useMsal } from "../../Auth/msal-context";
import { v4 as uuidv4 } from 'uuid';
import Auth from '../../Auth/Auth';
import './BackfillRequest.scss';
import check from '../../images/check.png';
import IsLoadingBar from '../isLoading';

import fetchShock from '../../images/10607-dog-avatar-shock.png';
const auth = new Auth();

function BackfillRequest(props) {
  const [ isLoading, setIsLoading] = useState(true);
  const [ backupAvailable, setBackupAvailable] = useState(false);
  const [ backfillSubmitted, setBackfillSubmitted] = useState(false);
  const [ backfillCheck, setBackfillCheck] = useState(false);
  const [ requestError, setRequestError] = useState(null); 
  const [ chosenSupportApp, setChosenSupportApp] = useState([]); 
  
  const [ environment, setEnvironment] = useState("Select...");
  const [ backupFile, setBackupFile] = useState("Select...");
  const [ backupFileOther, setBackupFileOther] = useState("");
  
  const [ backupFiles, setBackupFiles] = useState([]);
  const [ myApps, setMyApps] = useState([]);

  const { user, userAltocumulus } = useMsal();

  useEffect(() => {
    checkBackupExists();
    
  },[]);

  const checkBackupExists = async () => {
    let accessToken = await auth.getToken();

    fetch(`/api/checkfornamespacebackups`, {
        method : "GET",
        headers: {
            'Content-Type' : 'application/json',
            'Authorization': "Bearer " + accessToken,
            "namespace": props.namespace
        },
    }).then(response => {
        if(response.status !== 200)
        {   
            let payload = [{
                status : response.status,
                rawmsg : response.statusText,
                cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                location: response.url,
                timestamp : Date.now(),
            }];
            throw {
                payload: payload,
                error: new Error()
              };
        }
        return  response.json();
    }).then(data => { 

        setBackupFiles(data);        
        setIsLoading(false);
        if(data.length > 0){
          getMySupportApps(data[0].Directory);
        }
        
    }).catch((error) => {
        window.apiError(error); 
    });    
  }; 
  
  const getMySupportApps = async (Directory) => {
    let accessToken = await auth.getToken();

    fetch('/api/getMySupportApps', {
        method : "GET",
        headers : {
            'Authorization': "Bearer " + accessToken,
            "teamid" : userAltocumulus.TeamId,
            "isadmin": userAltocumulus.IsAdmin
        }
    }).then(response => {
        if(response.status !== 200)
        {   
            let payload = [{
                status : response.status,
                rawmsg : response.statusText,
                cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                location: response.url,
                timestamp : Date.now(),
            }];
            throw {
                payload: payload,
                error: new Error()
            };
        }
        return  response.json();
    }).then(data => {
        setMyApps(data.filter(el => {
          return el.DBServer.substring(0,2) === Directory.substring(0,2);
        }));
    }).catch((error) => {
        console.error('Error:', error);
        window.apiError(error);
    });
  };

  async function processBackfillRequest(e){      
    e.preventDefault(); 
    setBackfillCheck(false);
    let jobId = uuidv4();
   
    let accessToken = await auth.getToken();

    let backfillData = {
      "JobID": jobId,
      "Namespace": props.namespace,
      "CaseNumber": props.caseNumber,
      "EnvironmentName":environment, 
      "BackupFile":backupFile === "Other" ? backupFileOther : backupFile, 
      "LeaserID": userAltocumulus.LeaserID, 
      "loginName":userAltocumulus.LoginName, 
      "Email": user.username, 
      "IsAdmin": userAltocumulus.IsAdmin, 
      "CanBackfillAll": userAltocumulus.CanUserBackfillAnySupportApp,
      "TeamID": userAltocumulus.TeamId
    };

    setBackfillSubmitted(true);
      fetch('/api/processBackfillRequest', {
      method: "POST",
      headers : {
        "Content-Type": "application/json",
        'Authorization': "Bearer " + accessToken
      },
      body : JSON.stringify(backfillData)
      }).then(response => response.text())
      .catch((error) => {
        console.log(error);
      });
    }

 const isDisabled = () => {
   if((environment === "Select..." ) || (backupFile.indexOf(".bak") < 1 && backupFileOther.indexOf(".bak") < 1)){
     return true;
   }
   return false;
 };

 const changeChosenSupportApp = (supportAppName) => {
  setEnvironment(supportAppName);
  setChosenSupportApp(myApps.filter(el => el.SupportAppName === supportAppName));
 };

 if(isLoading){
    return (
      <IsLoadingBar />
    );
  }

  if(backupFiles.length === 0){
    return (
      <div id="BackfillRequest">
          <div className="backfill-submitted p-3">
              <h5>No Backup File Found</h5>
              <h6>We were unable to find a backup file for the namespace <span><b>{props.namespace}</b></span>.</h6>
              
              <img src={fetchShock} />
              <h6>You can request a new backup using the backup request button.</h6>
              <Button variant="link" className="color-muted" onClick={() => props.close()}><small>Close</small></Button>
          </div>                
      </div>
    );
  }

 if(backfillCheck){
    return (
        <div id="BackfillRequest">
            <div className="backfill-submitted p-3">
                <h5>Backfill Confirmation</h5>
                <h6 style={{ wordBreak: "break-word"}}>You're are about to backfill <b>{environment}</b><br /> with <b>{backupFile === "Other" ? backupFileOther : backupFile}</b></h6>
                
                <i className="fa fa-question-circle" style={{fontSize: "165px", margin: "18px", color: "dodgerblue"}} />
                <Button variant="link" onClick={(e) => processBackfillRequest(e)}>Continue</Button>
                <Button variant="link" onClick={() => props.close()}><small className="text-muted">Cancel</small></Button>
            </div>                
        </div>
    );
 }

 if(backfillSubmitted){
    return (
        <div id="BackfillRequest">
            <div className="backfill-submitted p-3">
                <h5>Backfill Requested</h5>
                <h6>Your backfill request has been submitted.</h6>
                
                <img src={check} />
                <h5>You can check the progress at any time from Backfill Dashboard.</h5>
                <Button variant="link" className="color-muted" onClick={() => props.close()}><small>Close</small></Button>
            </div>                
        </div>
    );     
  }

  return (
    <div id="BackfillRequest">
      <Form>
        <Form.Group controlId="Namespace">
          <Form.Label>Support App:</Form.Label>
          
          <Form.Control as="select" value={environment} onChange={(e) => changeChosenSupportApp(e.target.value)}>
            <option>Select...</option> 
            {myApps.map((item,index) => 
              <option key={index} value={item.SupportAppName}>{item.SupportAppName}   ({item.ClientNamespace})</option>
            )}          
          </Form.Control>            
        </Form.Group>

        <div className="chosen_backup">
          {chosenSupportApp.length > 0 && (
            <>
              <p className="mb-1">
                <strong className="mr-2">Primary Owner:</strong><a href={`mailto:${chosenSupportApp[0].LeaserEmail}`}>{chosenSupportApp[0].LeaserEmail}</a>
              </p>
              <p className="mb-1">
                <strong className="mr-2">Estimated Backup Date:</strong>{chosenSupportApp[0].CreatedDate}
              </p>
              <p className="mb-1">
                <strong className="mr-2">Reservation Days:</strong>{chosenSupportApp[0].DaysLeftOnReservation}
              </p>
              <p className="mb-1">
                <strong className="mr-2">Current Client:</strong>{chosenSupportApp[0].ClientNamespace}
              </p>
              <p className="mb-1">
                <strong className="mr-2">Secondaries:</strong>{chosenSupportApp[0].Secondaries}
              </p>
              <p className="mb-1">
                <strong className="mr-2">Owner Comment:</strong>{chosenSupportApp[0].OwnerComment}
              </p>
              
            </>
          )}
          
        </div>

        <Form.Group controlId="Backupfile">
          <Form.Label>Backup File:</Form.Label>
          <Form.Control as="select" value={backupFile} onChange={(e) => setBackupFile(e.target.value) }>
            <option>Select...</option>  
            {backupFiles.map((item,index) => 
              <option key={index}>{item.BackupFileName}</option>
            )}  
            <option>Other</option>          
          </Form.Control>
          {backupFile === "Other" && (
            <Form.Control name="BackupFile" type="text" className="mt-3" placeholder="Enter backup file name..." value={backupFileOther} onChange={(e) => setBackupFileOther(e.target.value) }/>
          )}
          
        </Form.Group>
        
        <Button variant="primary" type="submit" className="float-right" onClick={() => setBackfillCheck(true)} disabled={isDisabled()}>
          Submit
        </Button>
      </Form>

      {requestError && (
          <h5 className="text-danger pl-3 mt-3">{requestError}</h5>
      )}
    </div>
  );
}

export default BackfillRequest;